import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@mui/material/Tooltip';
import { isWeekend } from 'date-fns';
import moment from 'moment';
import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { DateRangePickerDialog, EmptyContent, Loading } from '../../components/common/commons';
import CurrencyInput from '../../components/currencyInput/CurrencyInput.js';
import { NavBar } from '../../components/navbar';
import { getRevenda, getRevendasAssociadas, getUsuarioCompact, isDeveloper } from '../../config/auth';
import { AlertSuccess } from '../../shared/alert-manager';
import { Collection } from '../../shared/constants';
import { cellphoneMask, dangerConfirm, generateUUIDV7, goToFirebase, isNullOrEmpty, leadNormalBadge, normalizedField, platformMask, queryString, revendaNormalBadge, setPathWindow, takeIfIsNotNullOrEmpty, toastDismissLoading, toastLoading, toastSuccess, toastWarning, toCurrency, valueByMaximunChars, warningConfirm } from '../../shared/utils';
import { getAllClientsByRevendaIdsAndDate, getClientById, updateClientById } from '../../store/collections/clienteWorker';
import { getFirstParameterByClientId } from '../../store/collections/parameterWorker';
import { addQueue, deleteQueuesById, getAllQueuesScheduledByGroupAndReferenceId, getAllQueuesScheduledByType, updateQueueById } from '../../store/collections/queueWorker';
import { getRevendaById, updateRevendaById } from '../../store/collections/revendaWorker.js';
import { LeadClientModal } from '../cliente';
import { CriarNovaMatriz } from '../cliente/view/client-view';
import { WhatsAppMessageListBody } from '../developer/messages';

class LeadsManager extends React.Component {
	constructor(props) {
		super(props);
		const startDate = queryString("startDate") ? new moment(queryString("startDate"), "DD/MM/YYYY") : new moment().startOf('month')
		const endDate = queryString("endDate") ? new moment(queryString("endDate"), "DD/MM/YYYY") : new moment().endOf('month')
		const titleRangeDate = `De ${startDate.format("DD/MM/YYYY")} até ${endDate.format("DD/MM/YYYY")}`
		this.state = {
			columns: [],
			leadId: queryString("leadId"),
			isDeveloper: isDeveloper(),
			revendaId: getRevenda()?.id,
			state: "loading",
			draggedLead: null,
			draggedOver: null,
			showAddForm: false,
			startDate: startDate,
			endDate: endDate,
			newLead: {
				name: '',
				email: '',
				phone: '',
				value: '',
				source: ''
			},
			keyReminder: "novo-lembrete",
			titleRangeDate: titleRangeDate,
			scheduleType: "scheduled"
		}
		this.handleDragStart = this.handleDragStart.bind(this);
		this.handleDragOver = this.handleDragOver.bind(this);
		this.handleDragLeave = this.handleDragLeave.bind(this);
		this.handleDrop = this.handleDrop.bind(this);
		this.handleAddLead = this.handleAddLead.bind(this);
		this.handleDeleteLead = this.handleDeleteLead.bind(this);
		this.formatCurrency = this.formatCurrency.bind(this);
		this.getTotalValue = this.getTotalValue.bind(this);
		this.toggleAddForm = this.toggleAddForm.bind(this);
		this.loadLeadDetailIfNeed()
		this.loadLeads()
	}

	transformLead = (lead) => {
		var leadUpdatedAt = null
		if (isNullOrEmpty(lead.leadUpdatedAt)) {
			leadUpdatedAt = moment(lead.createdAt.seconds * 1000)
		} else {
			leadUpdatedAt = moment(lead.leadUpdatedAt.seconds * 1000)
		}
		var attention = ""
		if (lead.leadStatus !== "fechado" && lead.leadStatus !== "seminteresse") {
			const days = moment().diff(leadUpdatedAt, "days")
			if (days != 0) {
				if (days > 2) {
					attention = "warning"
				} else if (days >= 7) {
					attention = "danger"
				}
			}
		}
		const notes = !isNullOrEmpty(lead.leadNotes) ? lead.leadNotes.filter(e => e.leadStatus !== "anotacao").sort((a, b) => b.createdAt.seconds - a.createdAt.seconds)[0]?.message ?? "" : ""
		return {
			revendaId: lead.revendaId,
			id: lead.id,
			name: lead.nome,
			email: lead.email,
			representative: lead.representante,
			total: lead.total ?? 0,
			phone: cellphoneMask(lead.celular),
			createdAt: moment(lead.createdAt.seconds * 1000).format("DD/MM/YYYY [às] HH:mm"),
			source: platformMask(lead.platform),
			lastUpdate: isNullOrEmpty(lead.leadNotes) ? "Nunca" : leadUpdatedAt.format("DD/MM/YYYY [às] HH:mm"),
			leadUpdatedDate: leadUpdatedAt,
			note: valueByMaximunChars(notes, 150, true),
			comercial: lead?.revendedor?.nome ?? "",
			attention: attention,
			slots: lead.slots,
		}
	}

	loadLeads = async (hiddenLoading) => {
		setPathWindow(`/revenda/leads?startDate=${this.state.startDate.format("DD/MM/YYYY")}&endDate=${this.state.endDate.format("DD/MM/YYYY")}`)
		if (!hiddenLoading) {
			this.setState({ state: "loading" })
		}
		const resales = getRevendasAssociadas()
		const clients = await getAllClientsByRevendaIdsAndDate({
			revendaIds: resales.map(e => e.value),
			startDate: this.state.startDate.toDate(),
			endDate: this.state.endDate.toDate()
		})
		this.setState({ clients: clients }, this.reloadCards)
	}

	loadLeadDetailIfNeed = async () => {
		if (isNullOrEmpty(this.state.leadId)) {
			return
		}
		this.onShowLeadModal({ id: this.state.leadId })
	}

	reloadCards = () => {
		const clients = this.state.clients
		const awaiting = clients.filter(e => isNullOrEmpty(e.leadStatus) || e.leadStatus === "aguardando").map(this.transformLead)
		const contacted = clients.filter(e => e.leadStatus === "ligacao" || e.leadStatus === "whatsapp").map(this.transformLead)
		const testing = clients.filter(e => e.leadStatus === "testando").map(this.transformLead)
		const closed = clients.filter(e => e.leadStatus === "seminteresse").map(this.transformLead)
		const proposal = clients.filter(e => e.leadStatus === "proposta-enviada").map(this.transformLead)
		const won = clients.filter(e => e.leadStatus === "fechado").map(this.transformLead)
		this.setState({
			columns: [
				{
					id: 'awaiting',
					title: 'Aguardando',
					color: 'secondary',
					leads: awaiting,
					total: awaiting.reduce((total, lead) => total + lead.total, 0),
				},
				{
					id: 'contacted',
					title: 'Conversando',
					color: 'info',
					leads: contacted,
					total: contacted.reduce((total, lead) => total + lead.total, 0),
				},
				{
					id: 'testing',
					title: 'Testando',
					color: 'warning',
					leads: testing,
					total: testing.reduce((total, lead) => total + lead.total, 0),
				},
				{
					id: 'proposal',
					title: 'Proposta',
					color: 'warning',
					leads: proposal,
					total: proposal.reduce((total, lead) => total + lead.total, 0),
				},
				{
					id: 'won',
					title: 'Fechado',
					color: 'success',
					leads: won,
					total: won.reduce((total, lead) => total + lead.total, 0),
				},
				{
					id: 'lost',
					title: 'Perdido',
					color: 'danger',
					leads: closed,
					total: closed.reduce((total, lead) => total + lead.total, 0),
				}
			],
			state: "fill"
		})
	}

	handleDragStart(e, lead, columnId) {
		this.setState({
			draggedLead: { lead, sourceColumn: columnId }
		});
		e.dataTransfer.effectAllowed = 'move';
	}

	handleDragOver(e, columnId) {
		e.preventDefault();
		e.dataTransfer.dropEffect = 'move';
		this.setState({ draggedOver: columnId });
	}

	handleDragLeave(e) {
		if (!e.currentTarget.contains(e.relatedTarget)) {
			toastDismissLoading()
			this.setState({ draggedOver: null });
		}
	}

	updateLead = async (item, columnId) => {
		if (item.sourceColumn === columnId) {
			return
		}
		const client = await getClientById({ id: item.lead.id })
		if (columnId === "testing") {
			const confirm = await warningConfirm({ message: "Deseja receber um lembrete daqui 5 dias para entrar em contato com este cliente?" })
			if (confirm) {
				this.createReminderForANewTestingLead({ lead: client })
			}
		}
		if (columnId === "proposal") {
			this.showPriceModal(client)
		}
		switch (columnId) {
			case "awaiting":
				client.leadStatus = "aguardando"
				break
			case "contacted":
				client.leadStatus = "whatsapp"
				break
			case "testing":
				client.leadStatus = "testando"
				break
			case "won":
				client.leadStatus = "fechado"
				break
			case "proposal":
				client.leadStatus = "proposta-enviada"
				break
			case "lost":
				client.leadStatus = "seminteresse"
				break
		}
		if (isNullOrEmpty(client.leadNotes)) {
			client.leadNotes = []
		}
		client.leadNotes.push({
			id: generateUUIDV7(),
			currentLeadStatus: "anotacao",
			message: `Movido para ${client.leadStatus} via CRM.`,
			createdAt: new Date(),
			createdBy: getUsuarioCompact()
		})
		client.leadUpdatedAt = new Date()
		client.leadUpdatedAtBy = getUsuarioCompact()
		const clients = this.state.clients.filter(e => e.id !== client.id)
		clients.push(client)
		this.setState({ clients: clients })
		this.reloadCards()

		await updateClientById({ id: client.id, data: client })
		toastDismissLoading()
	}

	handleDrop(e, targetColumnId) {
		e.preventDefault();
		this.setState({ draggedOver: null });

		const { draggedLead } = this.state;
		if (!draggedLead || draggedLead.sourceColumn === targetColumnId) {
			this.setState({ draggedLead: null });
			return;
		}

		const newColumns = this.state.columns.map(column => {
			if (column.id === draggedLead.sourceColumn) {
				return {
					...column,
					leads: column.leads.filter(lead => lead.id !== draggedLead.lead.id)
				};
			}
			if (column.id === targetColumnId) {
				return {
					...column,
					leads: [...column.leads, draggedLead.lead]
				};
			}
			return column;
		});

		this.setState({
			columns: newColumns,
			draggedLead: null
		});
		this.updateLead(draggedLead, targetColumnId)
	}

	handleAddLead(e) {
		e.preventDefault();
		const { newLead } = this.state;
		if (!newLead.name || !newLead.email) return;

		const lead = {
			id: Date.now().toString(),
			...newLead,
			value: parseFloat(newLead.value) || 0,
			createdAt: new Date().toISOString().split('T')[0]
		};

		const newColumns = this.state.columns.map(column => {
			if (column.id === 'new') {
				return {
					...column,
					leads: [lead, ...column.leads]
				};
			}
			return column;
		});

		this.setState({
			columns: newColumns,
			newLead: { name: '', email: '', phone: '', value: '', source: '' },
			showAddForm: false
		});
	}

	handleDeleteLead(leadId, columnId) {
		const newColumns = this.state.columns.map(column => {
			if (column.id === columnId) {
				return {
					...column,
					leads: column.leads.filter(lead => lead.id !== leadId)
				};
			}
			return column;
		});
		this.setState({ columns: newColumns });
	}

	toggleAddForm() {
		this.setState({ showAddForm: !this.state.showAddForm });
	}

	formatCurrency(value) {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD'
		}).format(value);
	}

	getTotalValue() {
		return this.state.columns.reduce((total, column) => {
			return total + column.leads.reduce((colTotal, lead) => colTotal + lead.value, 0);
		}, 0);
	}

	onShowLeadModal = async (lead) => {
		toastLoading("Aguarde...")
		const client = await getClientById({ id: lead.id })
		toastDismissLoading()
		this.setState({
			isShowingLeadModal: true,
			currentLead: client
		})
	}

	hideLeadModal = () => {
		this.setState({ isShowingLeadModal: false })
	}

	addNewNote = () => {
		this.setState({ isShowingLeadNoteModal: true })
	}

	showRangeDate = () => {
		this.setState({ isRangeDateOpen: true })
	}

	hideRangeDate = () => {
		this.setState({ isRangeDateOpen: false })
	}

	applyDates = ({ startDate, endDate }) => {
		const titleRangeDate = `De ${startDate.format("DD/MM/YYYY")} até ${endDate.format("DD/MM/YYYY")}`
		this.setState({ startDate: startDate, endDate: endDate, titleRangeDate: titleRangeDate }, this.loadLeads)
	}

	showReminderModal = async () => {
		toastLoading("Aguarde...")
		const items = await getAllQueuesScheduledByGroupAndReferenceId({ group: "COMERCIAL-REMINDER", referenceId: this.state.currentLead?.id })
		this.setState({ reminderSchedules: items })
		toastDismissLoading()
		this.setState({ isShowingReminderModal: true })
	}

	hideReminderModal = () => {
		this.setState({ isShowingReminderModal: false })
	}

	handleReminderStartDateChange = (newValue) => {
		this.setState({ reminderDate: newValue })
	}

	confirmReminder = async () => {
		if (isNullOrEmpty(this.state.reminderNote)) {
			toastWarning("Preencha a anotação.")
			return
		}
		if (isNullOrEmpty(this.state.reminderDate)) {
			toastWarning("Preencha a data e hora do lembrete.")
			return
		}
		if (isNullOrEmpty(this.state.reminderHour)) {
			toastWarning("Preencha a hora do lembrete.")
			return
		}
		const date = moment(`${this.state.reminderDate} ${this.state.reminderHour}:00`, "YYYY-MM-DD HH:mm").toDate()
		if (!this.state.isDeveloper && date.getTime() < new Date().getTime()) {
			toastWarning("A data e hora do lembrete não podem ser anteriores à data atual.")
			return
		}
		this.hideReminderModal()
		toastLoading("Salvando...")
		const lead = this.state.currentLead
		const user = getUsuarioCompact()
		const parameter = await getFirstParameterByClientId({ clienteId: lead.clienteId })
		const revenda = getRevenda()
		const data = {
			origin: "WhatsApp",
			status: "scheduled",
			type: "WHATSAPP_MESSAGE_WITH_TEMPLATE",
			group: "COMERCIAL-REMINDER",
			scheduledAt: date,
			body: {
				X_API_KEY: parameter.X_API_KEY,
				clienteId: lead.clienteId,
				estacionamentoId: parameter.estacionamentoId,
				template: "NO_TEMPLATE",
				referenceId: lead.id,
				message: `
*Você tem um lembrete:*

${this.state.reminderNote}

*Cliente:* ${lead.nome}
*Celular:* ${cellphoneMask(lead.celular)}
*Representante:* ${lead.representante}

Detalhes do lead:
${revenda.siteAdmin}/revenda/leads?leadId=${lead.id}
				`,
				phone: normalizedField(user.phone),
				channel: "COMERCIAL"
			}
		}
		await addQueue({ data: data })
		toastDismissLoading()
		toastSuccess("Lembrete salvo com sucesso.")
	}

	createReminderForANewTestingLead = async ({ lead }) => {
		const user = getUsuarioCompact()
		const revenda = getRevenda()
		const data = {
			origin: "WhatsApp",
			status: "scheduled",
			type: "WHATSAPP_MESSAGE_WITH_TEMPLATE",
			group: "COMERCIAL-REMINDER",
			scheduledAt: moment().add(5, 'days').set({ hour: 9, minute: 0 }).toDate(),
			body: {
				X_API_KEY: revenda.whatsAppProvider,
				clienteId: lead.id,
				estacionamentoId: revenda.id,
				template: "NO_TEMPLATE",
				referenceId: lead.id,
				message: `
*Você tem um lembrete:*

Este lead esta no período de testes há 5 dias, que tal entrar em contato com ele?

*Cliente:* ${lead.nome}
*Celular:* ${cellphoneMask(lead.celular)}
*Representante:* ${lead.representante}

Detalhes do lead:
${revenda.siteAdmin}/revenda/leads?leadId=${lead.id}
				`,
				phone: normalizedField(user.phone),
				channel: "COMERCIAL"
			}
		}
		await addQueue({ data: data })
		toastSuccess("Lembrete salvo com sucesso.")
	}

	removeReminder = async (item) => {
		this.setState({ reminderSchedules: this.state.reminderSchedules.filter(e => e.id !== item.id) })
		await deleteQueuesById({ id: item.id })
	}

	showScheduleModal = () => {
		this.setState({ isShowScheduleModal: true })
	}

	showSettingsModal = async () => {
		toastLoading("Aguarde...")
		const revenda = await getRevendaById({ id: this.state.revendaId })
		this.setState({
			templateMensagemBoasVindasComercialWhatsApp: revenda.templateMensagemBoasVindasComercialWhatsApp,
			templateMensagemBoasVindas2ComercialWhatsApp: revenda.templateMensagemBoasVindas2ComercialWhatsApp
		})
		toastDismissLoading()
		this.setState({ isShowSettingsModal: true })
	}

	hideSettingsModal = () => {
		this.setState({ isShowSettingsModal: false })
	}

	confirmSettings = async () => {
		if (isNullOrEmpty(this.state.templateMensagemBoasVindasComercialWhatsApp) || isNullOrEmpty(this.state.templateMensagemBoasVindas2ComercialWhatsApp)) {
			toastWarning("Preencha todos os campos.")
			return
		}
		const confirm = await warningConfirm({ message: "Tem certeza que deseja fazer essa alteração?" })
		if (!confirm) return
		toastLoading("Salvando...")
		const revenda = await getRevendaById({ id: this.state.revendaId })
		revenda.templateMensagemBoasVindasComercialWhatsApp = this.state.templateMensagemBoasVindasComercialWhatsApp
		revenda.templateMensagemBoasVindas2ComercialWhatsApp = this.state.templateMensagemBoasVindas2ComercialWhatsApp
		await updateRevendaById({ id: revenda.id, data: revenda })
		toastSuccess("Alteração salva com sucesso.")
		this.hideSettingsModal()
	}

	showSchedulesAddedModal = async () => {
		toastLoading("Aguarde...")
		const items = await getAllQueuesScheduledByType({ type: "COMERCIAL_SHOOTING_MESSAGES" })
		this.setState({ messageSchedules: items })
		toastDismissLoading()
		this.setState({ isShowSchedulesAddedModal: true })
	}

	hideSchedulesAddedModal = () => {
		this.setState({ isShowSchedulesAddedModal: false })
	}

	removeSchedule = async (item) => {
		const confirm = await dangerConfirm({ message: "Tem certeza que deseja remover essa mensagem?" })
		if (!confirm) return
		this.setState({ messageSchedules: this.state.messageSchedules.filter(e => e.id !== item.id) })
		await deleteQueuesById({ id: item.id })
	}

	showShootingMessageModal = async (item) => {
		this.setState({ currentShootingMessage: item })
		this.setState({ shootingLeads: item.body.leads })
		this.setState({ isShowShootingMessageModal: true })
	}

	hideShootingMessageModal = () => {
		this.setState({ isShowShootingMessageModal: false })
	}

	removeLeadFromMessage = async (item) => {
		const items = this.state.currentShootingMessage.body.leads.filter(e => e.id !== item.id)
		if (isNullOrEmpty(items)) {
			toastWarning("Não é possível remover todos os leads da mensagem.")
			return
		}
		const confirm = await dangerConfirm({ message: "Tem certeza que deseja remover este lead da mensagem?" })
		if (!confirm) return
		const currentShootingMessage = this.state.currentShootingMessage
		currentShootingMessage.body.leads = items
		const messageSchedules = this.state.messageSchedules.filter(e => e.id !== currentShootingMessage.id)
		messageSchedules.push(currentShootingMessage)
		this.setState({ messageSchedules: messageSchedules })
		this.setState({ shootingLeads: items })
		await updateQueueById({ id: currentShootingMessage.id, data: currentShootingMessage })
	}

	showWhatsAppMessage = async (item) => {
		this.setState({ referenceId: item.id })
		this.setState({ showWhatsAppMessagesModal: true })
	}

	hideWhatsAppMessages = () => {
		this.setState({ showWhatsAppMessagesModal: false })
	}

	hideScheduleModal = () => {
		this.setState({ isShowScheduleModal: false })
	}

	changeBatchMessageCategory = (e) => {
		this.setState({ selectAll: false })
		this.setState({ category: e.target.value })
		this.setState({ batchLeads: this.state.columns.find(lead => lead.id === e.target.value)?.leads ?? [] })
	}

	onSelecAllBatchLeads = (e) => {
		const selectAll = e.target.checked
		var batchLeads = this.state.batchLeads
		for (const lead of batchLeads) {
			lead.isChecked = selectAll
		}
		this.setState({ batchLeads: batchLeads, selectAll: selectAll })
	}

	onSelectBatchLead = (e, lead) => {
		lead.isChecked = e.target.checked
		this.setState({ batchLeads: this.state.batchLeads })
	}

	confirmSchedule = async () => {
		const leads = this.state.batchLeads.filter(e => e.isChecked)
		if (isNullOrEmpty(leads)) {
			toastWarning("Selecione ao menos um cliente para enviar a mensagem.")
			return
		}
		var date = undefined
		if (this.state.scheduleType === "scheduled") {
			if (isNullOrEmpty(this.state.scheduleDate)) {
				toastWarning("Preencha a data e hora da mensagem.")
				return
			}
			if (isNullOrEmpty(this.state.scheduleMessage)) {
				toastWarning("Preencha a mensagem.")
				return
			}
			if (isNullOrEmpty(this.state.scheduleHour)) {
				toastWarning("Preencha a hora do envio.")
				return
			}
			date = moment(`${this.state.scheduleDate} ${this.state.scheduleHour}:00`, "YYYY-MM-DD HH:mm").toDate()
			if (!this.state.isDeveloper && date.getTime() < new Date().getTime()) {
				toastWarning("A data e hora da mensagem não podem ser anteriores à data atual.")
				return
			}
			if (!this.state.isDeveloper && isWeekend(date)) {
				toastWarning("Não é possível enviar mensagem no fim de semana.")
				return
			}
		}
		if (this.state.scheduleType === "in-queue") {
			const confirm = await dangerConfirm({
				title: "Atenção",
				message: `Tem certeza que deseja enviar a mensagem:\n\n\n${this.state.scheduleMessage}`
			})
			if (!confirm) return
		}
		this.hideScheduleModal()
		toastLoading("Agendando mensagens...")
		const data = {
			origin: "Disparo em massa",
			status: this.state.scheduleType,
			type: "COMERCIAL_SHOOTING_MESSAGES",
			scheduledAt: date,
			body: {
				channel: "COMERCIAL",
				leads: leads.map(e => ({
					id: e.id,
					name: e.name,
					phone: e.phone,
					representative: e.representative
				})),
				moveLead: this.state.moveLead,
				message: this.state.scheduleMessage
			}
		}
		await addQueue({ data: data })
		if (this.state.scheduleType === "scheduled") {
			toastSuccess("Mensagens agendadas com sucesso.")
		} else {
			toastSuccess("Mensagens enviadas para a fila.")
		}
	}

	showPriceModal = async (lead) => {
		this.setState({
			currentLead: lead,
			priceTotal: lead.total,
			isShowPriceModal: true
		})
	}

	hidePriceModal = () => {
		this.setState({ isShowPriceModal: false })
	}

	changePriceTotal = (event, maskedvalue, floatvalue) => {
		this.setState({ priceTotal: floatvalue })
	}

	confirmPriceTotal = async () => {
		const lead = this.state.currentLead
		const total = parseFloat(this.state.priceTotal ?? 0)
		lead.total = total
		this.setState({ currentLead: lead })
		this.hidePriceModal()
		await updateClientById({ id: lead.id, data: lead })
		this.loadLeads(true)
	}

	render() {
		const { columns, draggedOver } = this.state;
		return (
			<NavBar>
				{
					this.state.state === "loading" && <Loading />
				}
				{
					this.state.state === "fill" &&
					<div className="container-fluid min-vh-100">
						<div className="row mb-4">
							<div className="col-12">
								<div className="card-header d-flex justify-content-between align-items-center">
									<div className='col-lg-6'>
										<h4>Leads qualificados</h4>
									</div>
									<div className='btn-group'>
										<button type="button" onClick={this.showSettingsModal} className="btn btn-success">
											Configurações
											<i className="fa-solid fa-gear mx-2" />
										</button>
										<button type="button" onClick={this.showSchedulesAddedModal} className="btn btn-success">
											Mensagens
											<i className="fa-solid fa-calendar-days mx-2" />
										</button>
										<button type="button" onClick={this.showScheduleModal} className="btn btn-success">
											Disparar
											<i class="fa-brands fa-whatsapp mx-2" />
										</button>
										<button type="button" onClick={() => { this.setState({ showNewCompanyModal: true }) }} className="btn btn-primary">
											Novo
											<i className="fas fa-plus mx-2" />
										</button>
										<button type="button" onClick={() => { this.showRangeDate() }} className="btn btn-secondary">
											{this.state.titleRangeDate}
											<i className="fa-solid fa-filter mx-2" />
										</button>
									</div>
								</div>
								<div className="row g-3 mt-2">
									<div className="col-md-1">
										<div className="card bg-primary text-white">
											<div className="card-body text-center">
												<h2 className="card-title">
													{columns.reduce((total, col) => total + col.leads.length, 0)}
												</h2>
												<p className="card-text">Total</p>
											</div>
										</div>
									</div>
									<div className="col-md-2">
										<div className="card bg-secondary text-white">
											<div className="card-body text-center">
												<h2 className="card-title">
													{columns.find(col => col.id === 'awaiting')?.leads?.length ?? 0}
												</h2>
												<p className="card-text">Aguardando</p>
											</div>
										</div>
									</div>
									<div className="col-md-3">
										<div className="card bg-info text-white">
											<div className="card-body text-center">
												<h2 className="card-title">
													{columns.find(col => col.id === 'contacted')?.leads?.length ?? 0}
												</h2>
												<p className="card-text">Conversando</p>
											</div>
										</div>
									</div>
									<div className="col-md-3">
										<div className="card bg-warning text-white">
											<div className="card-body text-center">
												<h2 className="card-title">
													{columns.find(col => col.id === 'testing')?.leads?.length ?? 0}
												</h2>
												<p className="card-text">Testando</p>
											</div>
										</div>
									</div>
									<div className="col-md-3">
										<div className="card bg-success text-white">
											<div className="card-body text-center">
												<h2 className="card-title">
													{columns.find(col => col.id === 'won')?.leads?.length ?? 0}
												</h2>
												<p className="card-text">Fechado</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="row g-3" style={{ overflowX: 'auto' }}>
							{columns.map(column => (
								<div key={column.id} className="col-lg-2">
									<div className={`card border-${column.color} h-100 ${draggedOver === column.id ? 'shadow-lg border-3' : ''}`}
										onDragOver={(e) => this.handleDragOver(e, column.id)}
										onDragLeave={this.handleDragLeave}
										onDrop={(e) => this.handleDrop(e, column.id)}
										style={{ minHeight: '500px' }}>
										<div className={`card-header bg-${column.color} text-white d-flex justify-content-between align-items-center`}>
											<div className="d-flex align-items-center">
												<span className={`badge bg-light text-dark`}>
													<span className={`text-${column.color}`}>{column.leads.length}</span>
												</span>
												<span className="card-title mb-0 mx-2">
													{column.title}
												</span>
											</div>
											<span className={`badge bg-light text-dark`}>
												<span className={`text-${column.color}`}>{toCurrency(column.total)}</span>
											</span>
										</div>
										<div className="card-body p-2" style={{ maxHeight: '450px', overflowY: 'auto' }}>
											{column.leads.map(lead => (
												<div key={lead.id}
													draggable
													onDragStart={(e) => this.handleDragStart(e, lead, column.id)}
													className="card mb-2 shadow-sm"
													style={{ cursor: 'move' }} >
													<div className="card-body p-3">
														<div className="d-flex justify-content-between align-items-start mb-2">
															<h6 className="card-title mb-1">{lead.name}</h6>
															<span className='btn-group'>
																<button className={`btn btn-${column.color} text-white btn-sm`} onClick={(e) => this.onShowLeadModal(lead)}>
																	<i className="fas fa-note-sticky" />
																</button>
															</span>
														</div>

														<div className="small text-muted">
															<div className="mb-1">
																<strong>📧</strong>
																<span className='mx-2'>{valueByMaximunChars(lead.email, 15, true)}</span>
															</div>
															{
																!isNullOrEmpty(lead.phone) &&
																<div className="mb-1">
																	<strong>
																		<i className="fa-brands fa-whatsapp" />
																	</strong>
																	<span className='mx-2'>
																		<a href={`https://wa.me/+55${normalizedField(lead.phone)}`} target="_blank" rel="noopener noreferrer">
																			{lead.phone}
																		</a>
																	</span>
																</div>
															}
															<div className="mb-1">
																<strong>📅</strong>
																<span className='mx-2'>{lead.createdAt}</span>
															</div>
															<div className="mb-1">
																<strong>🕑</strong>
																<span className='mx-2'>{lead.lastUpdate}</span>
															</div>
															{
																!isNullOrEmpty(lead.slots) &&
																<div>
																	<strong>🔢</strong>
																	<span className='mx-2'>{lead.slots} vagas</span>
																</div>
															}
															{
																!isNullOrEmpty(lead.comercial) &&
																<div>
																	<strong>🧑</strong>
																	<span className='mx-2'>{lead.comercial}</span>
																</div>
															}
															{
																lead.total > 0 &&
																<div className="mb-1">
																	<strong>💰</strong>
																	<span className='mx-2'>{toCurrency(lead.total)}</span>
																</div>
															}
															{
																!isNullOrEmpty(lead.note) &&
																<div>
																	<strong>📝</strong>
																	<span className='mx-2'>{lead.note}</span>
																</div>
															}
															{
																!isNullOrEmpty(lead.source) &&
																<div className='mt-2'>
																	<span className={`badge bg-${column.color}`}>
																		{lead.source}
																	</span>
																</div>
															}
															<div className='mt-2'>
																{revendaNormalBadge(lead.revendaId)}
															</div>
														</div>
													</div>
													{
														column.id !== "won" && column.id !== "lost" && <>
															{
																lead.lastUpdate == "Nunca" ?
																	<div className='card-footer bg-warning text-white'>
																		É preciso entrar em contato.
																	</div> :
																	<>
																		{
																			lead.attention == "warning" &&
																			<div className='card-footer bg-danger text-white'>
																				Última atualização há {moment().diff(lead.leadUpdatedDate, "days")} dias.
																			</div>
																		}
																		{
																			lead.attention == "danger" &&
																			<div className='card-footer bg-danger text-white'>
																				Última atualização há {moment().diff(lead.leadUpdatedDate, "days")} dias.
																			</div>
																		}
																	</>
															}
														</>
													}
												</div>
											))}
											{
												column.leads.length === 0 && (
													<div className="text-center text-muted py-5">
														<p>Nenhum lead na categoria</p>
														<small>Você pode arrastar novos leads para cá.</small>
													</div>
												)}
										</div>
									</div>
								</div>
							))}
						</div>
						{
							this.state.isRangeDateOpen &&
							<DateRangePickerDialog
								onClose={this.hideRangeDate}
								startDate={this.state.startDate}
								endDate={this.state.endDate}
								onConfirm={this.applyDates} />
						}
						<Dialog maxWidth="lg" fullWidth onClose={this.hideLeadModal} open={this.state.isShowingLeadModal}>
							<MuiDialogTitle className='text-center'>
								Detalhes do lead
							</MuiDialogTitle>
							<MuiDialogContent>
								<div className='row'>
									<div className='col-lg-6'>
										<div className="col-lg-12">
											<strong>Nome matriz: </strong> {this.state.currentLead?.nome}
										</div>
										{
											this.state.currentLead?.razaoSocial &&
											<div className="col-lg-12">
												<strong>Razão social: </strong> {this.state.currentLead?.razaoSocial}
											</div>
										}
										<div className="col-lg-12">
											<strong>Documento: </strong> {this.state.currentLead?.documento}
										</div>
										<div className="col-lg-12">
											<strong>Representante: </strong> {this.state.currentLead?.representante}
										</div>
										<div className="col-lg-12">
											<strong>Celular: </strong> {this.state.currentLead?.celular}
											<a href={`https://wa.me/+55${normalizedField(this.state.currentLead?.phone)}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-success mx-2">
												<i className="fa-brands fa-whatsapp" />
											</a>
										</div>
										<div className="col-lg-12">
											<strong>E-mail: </strong> {this.state.currentLead?.email}
										</div>
										{
											!isNullOrEmpty(this.state.currentLead?.slots) &&
											<div className="col-lg-12">
												<strong>Vagas: </strong> {this.state.currentLead?.slots}
											</div>
										}
										{
											this.state.currentLead?.createdAt !== undefined &&
											<div className="col-lg-12">
												<strong>Desde: </strong> {moment(this.state.currentLead?.createdAt?.seconds * 1000).format("DD/MM/YYYY [às] HH:mm")}
											</div>
										}
										<div className="col-lg-12">
											<strong>Origem: </strong>
											{platformMask(this.state.currentLead?.platform)}
										</div>
										<div className="col-lg-12">
											<strong>Indicador: </strong> {takeIfIsNotNullOrEmpty(this.state.currentLead?.dealer) ?? "Não informado"}
										</div>
										<div className='col-lg-12'>
											<strong>Status do lead: </strong>
											<div>
												{leadNormalBadge(this.state.currentLead?.leadStatus)}
											</div>
										</div>
									</div>
									<div className='col-lg-6'>
										{
											isNullOrEmpty(this.state.currentLead?.leadNotes) ?
												<EmptyContent text="Nenhuma anotação cadastrada." /> :
												<table className="table table-responsive mt-3">
													<tbody>
														<tr>
															<td align='center'><strong></strong></td>
															<td><strong>Data</strong></td>
															<td><strong>Observação</strong></td>
															<td><strong>Usuário</strong></td>
														</tr>
														{
															this.state.currentLead?.leadNotes?.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds).map(item =>
																<tr>
																	<td align='center' width={10}>
																		{leadNormalBadge(item.currentLeadStatus)}
																	</td>
																	<td>{moment(item.createdAt.seconds * 1000).format("DD/MM/YYYY [às] HH:mm")}</td>
																	<td>{item.message}</td>
																	<td>{item.createdBy?.nome}</td>
																</tr>
															)
														}
													</tbody>
												</table>
										}
									</div>
								</div>
							</MuiDialogContent>
							<MuiDialogActions>
								<div className='btn-group m-3'>
									{
										isNullOrEmpty(this.state.currentLead?.total) ?
											<button onClick={(e) => this.showPriceModal(this.state.currentLead)} className='btn btn-secondary'>
												<i className="fa-solid fa-money-bill-trend-up mx-2" />
												Valor
											</button> :
											<button onClick={(e) => this.showPriceModal(this.state.currentLead)} className='btn btn-secondary'>
												<i className="fa-solid fa-money-bill-trend-up mx-2" />
												Valor ({toCurrency(this.state.currentLead?.total)})
											</button>
									}
									<button onClick={(e) => this.showWhatsAppMessage(this.state.currentLead)} className='btn btn-secondary'>
										<i className="fas fa-comments mx-2" />
										Mensagens
									</button>
									{
										this.state.currentLead?.leadStatus !== "fechado" &&
										<>
											<button className="btn btn-secondary text-white" onClick={this.showReminderModal}>
												<i class="fa-solid fa-book mx-2" />
												Lembretes
											</button>
											<button className="btn btn-secondary" onClick={this.addNewNote}>
												<i className="fas fa-sticky-note mx-2" />
												Anotações
											</button>
										</>
									}
									<a href={`/revenda/cliente/${this.state.currentLead?.id}?tab=anotacoes`} target='_blank' rel="noopener noreferrer" className="btn btn-secondary">
										<i className="fas fa-eye mx-2" />
										Detalhes
									</a>
									<button onClick={this.hideLeadModal} className='btn btn-secondary'>Fechar</button>
								</div>
							</MuiDialogActions>
						</Dialog>
						{
							this.state.isShowingLeadNoteModal && <LeadClientModal clienteId={this.state.currentLead?.id} onClose={(e) => this.setState({ isShowingLeadNoteModal: false })} />
						}
						{
							this.state.showNewCompanyModal && <CriarNovaMatriz revendaId={this.state.currentLead?.revendaId} onClose={(e) => this.setState({ showNewCompanyModal: false })} />
						}
						<Dialog maxWidth={this.state.keyReminder === "novo-lembrete" ? "xs" : "md"} fullWidth onClose={this.hideReminderModal} open={this.state.isShowingReminderModal}>
							<MuiDialogTitle className='text-center'>
								Lembretes
							</MuiDialogTitle>
							<MuiDialogContent>
								<Tabs key={this.state.random} className='profile-dropdown-toggle' defaultActiveKey={1} activeKey={this.state.keyReminder} onSelect={k => this.setState({ keyReminder: k })}>
									<Tab eventKey="novo-lembrete" title="Novo">
										<div className='mt-3'>
											<AlertSuccess tag="Lembrete" message="Iremos te lembrar no WhatsApp sobre este cliente ( o cliente não receberá nenhuma mensagem )." />
										</div>
										<div className='row'>
											<div className='col-lg-6'>
												<label>Data</label>
												<input type="date" onChange={(e) => this.setState({ reminderDate: e.target.value })} value={this.state.reminderDate} className="form-control" />
											</div>
											<div className='col-lg-6'>
												<label>Horário</label>
												<select className="form-select" value={this.state.reminderHour} onChange={(e) => this.setState({ reminderHour: e.target.value })}>
													<option value="">Selecionar</option>
													<option value="9">Ás 9 horas</option>
													<option value="11">Ás 11 horas</option>
													<option value="12">Ás 12 horas</option>
													<option value="13">Ás 13 horas</option>
													<option value="14">Ás 14 horas</option>
													<option value="15">Ás 15 horas</option>
													<option value="16">Ás 16 horas</option>
													<option value="17">Ás 17 horas</option>
													{
														this.state.isDeveloper && <>
															<option value="18">Ás 18 horas</option>
															<option value="19">Ás 19 horas</option>
															<option value="20">Ás 20 horas</option>
															<option value="21">Ás 21 horas</option>
															<option value="22">Ás 22 horas</option>
															<option value="23">Ás 23 horas</option>
															<option value="00">Ás 24 horas</option>
														</>
													}
												</select>
											</div>
											<div className='col-lg-12'>
												<label>Lembrete</label>
												<textarea rows={5} onChange={(e) => this.setState({ reminderNote: e.target.value })} value={this.state.reminderNote} className="form-control" />
											</div>
										</div>
									</Tab>
									<Tab eventKey="todos" title="Todos">
										{
											isNullOrEmpty(this.state.reminderSchedules) ?
												<EmptyContent text="Nenhum lembrete agendado." /> :
												<div className='row'>
													<table className="table table-striped mt-3">
														<tr>
															<td></td>
															<td align='center' width={200}><strong>Celular</strong></td>
															<td align='center'><strong>Data</strong></td>
															<td align='center'><strong>Mensagem</strong></td>
															<td width={10}></td>
														</tr>
														<tbody>
															{
																this.state.reminderSchedules?.map(item =>
																	<tr key={item.id}>
																		<td>
																			{
																				item.status === "scheduled" &&
																				<span className='badge bg-warning'>Agendado</span>
																			}
																			{
																				item.status === "processed" &&
																				<span className='badge bg-success'>Enviado</span>
																			}
																		</td>
																		<td align='center'>{cellphoneMask(item.body.phone)}</td>
																		<td align='center'>{moment(item.scheduledAt.seconds * 1000).format("DD/MM/YYYY [às] HH:mm:ss")}</td>
																		<td align='center'>{item.body.message}</td>
																		<td width={10}>
																			<div className='btn-group'>
																				<button type="button" className="btn btn-danger btn-sm" onClick={(e) => this.removeReminder(item)}>
																					<i className="fas fa-trash" />
																				</button>
																			</div>
																		</td>
																	</tr>
																)
															}
														</tbody>
													</table>
												</div>
										}
									</Tab>
								</Tabs>
							</MuiDialogContent>
							<MuiDialogActions>
								<div className='btn-group m-3'>
									<button onClick={this.hideReminderModal} className='btn btn-secondary'>Fechar</button>
									{
										this.state.keyReminder === "novo-lembrete" &&
										<button className="btn btn-success" onClick={this.confirmReminder}>
											<i class="fa-solid fa-book mx-2" />
											Salvar lembrete
										</button>
									}
								</div>
							</MuiDialogActions>
						</Dialog>
						<Dialog maxWidth='lg' fullWidth onClose={this.hideScheduleModal} open={this.state.isShowScheduleModal}>
							<MuiDialogTitle className='text-center'>
								Disparos em massa
							</MuiDialogTitle>
							<MuiDialogContent>
								<div className='row'>
									<div className='col-lg-6'>
										<label>Categoria</label>
										<select className="form-select" value={this.state.category} onChange={(e) => this.changeBatchMessageCategory(e)}>
											<option value="">Selecione</option>
											<option value="awaiting">Aguardando</option>
											<option value="contacted">Conversando</option>
											<option value="testing">Testando</option>
										</select>
										{
											isNullOrEmpty(this.state.batchLeads) ?
												<EmptyContent text="Nenhum cliente selecionado." /> :
												<table className="table table-striped mt-3">
													<tbody>
														<tr key={-1}>
															<td width={10}>
																<div className="form-check form-switch">
																	<input className="form-check-input" id="fecharCaixaParcial" checked={this.state.selectAll} onChange={(e) => this.onSelecAllBatchLeads(e)} type="checkbox" />
																	<label className="form-check-label" htmlFor="fecharCaixaParcial">
																	</label>
																</div>
															</td>
															<td colSpan={2}><strong>Selecionar todos</strong></td>
															<td width={10}></td>
														</tr>
														{
															this.state.batchLeads?.map((item, index) =>
																<tr key={index}>
																	<td width={10}>
																		<div className="form-check form-switch">
																			<input className="form-check-input" id="fecharCaixaParcial" checked={item.isChecked} onChange={(e) => this.onSelectBatchLead(e, item)} type="checkbox" />
																		</div>
																	</td>
																	<td>{item.name}</td>
																	<td>{takeIfIsNotNullOrEmpty(item.phone) ?? "-"}</td>
																	<td>
																		<a href={`/revenda/cliente/${item.id}`} target='_blank' className="btn btn-primary btn-sm">
																			<i className="fas fa-eye" />
																		</a>
																	</td>
																</tr>
															)
														}
													</tbody>
												</table>
										}
									</div>
									<div className='col-lg-6'>
										<div className='row'>
											<div className='col-lg-4'>
												<label>Tipo</label>
												<select className="form-select" value={this.state.scheduleType} onChange={(e) => this.setState({ scheduleType: e.target.value })}>
													<option value="scheduled">Agendada</option>
													<option value="in-queue">Enviar agora</option>
												</select>
											</div>
											{
												this.state.scheduleType === 'scheduled' && <>
													<div className='col-lg-4'>
														<label>Data</label>
														<input type="date" onChange={(e) => this.setState({ scheduleDate: e.target.value })} value={this.state.scheduleDate} className="form-control" />
													</div>
													<div className='col-lg-4'>
														<label>Horário</label>
														<select className="form-select" value={this.state.scheduleHour} onChange={(e) => this.setState({ scheduleHour: e.target.value })}>
															<option value="">Selecionar</option>
															<option value="9">Ás 9 horas</option>
															<option value="11">Ás 11 horas</option>
															<option value="12">Ás 12 horas</option>
															<option value="13">Ás 13 horas</option>
															<option value="14">Ás 14 horas</option>
															<option value="15">Ás 15 horas</option>
															<option value="16">Ás 16 horas</option>
															<option value="17">Ás 17 horas</option>
															{
																this.state.isDeveloper &&
																<>
																	<option value="18">Ás 18 horas</option>
																	<option value="19">Ás 19 horas</option>
																	<option value="20">Ás 20 horas</option>
																	<option value="21">Ás 21 horas</option>
																	<option value="22">Ás 22 horas</option>
																	<option value="23">Ás 23 horas</option>
																</>
															}
														</select>
													</div>
												</>
											}
											<div className='col-lg-12'>
												<label>Mensagem</label>
												<textarea rows={5} onChange={(e) => this.setState({ scheduleMessage: e.target.value })} value={this.state.scheduleMessage} className="form-control" />
											</div>
											<div className='col-lg-12 mt-2'>
												<AlertSuccess tag="Variaveis" message="{{REPRESENTANTE}} para o nome do representante." />
											</div>
											<div className='col-lg-6'>
												<label>Mover lead para a coluna:</label>
												<select className="form-select" value={this.state.moveLead} onChange={(e) => this.setState({ moveLead: e.target.value })}>
													<option value="">Selecionar</option>
													<option value="whatsapp">Conversando</option>
													<option value="testando">Testando</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</MuiDialogContent>
							<MuiDialogActions>
								<div className='btn-group m-3'>
									<button onClick={this.hideScheduleModal} className='btn btn-secondary'>Fechar</button>
									<button onClick={this.confirmSchedule} className='btn btn-success'>Confirmar</button>
								</div>
							</MuiDialogActions>
						</Dialog>
						<Dialog maxWidth='md' fullWidth onClose={this.hideSchedulesAddedModal} open={this.state.isShowSchedulesAddedModal}>
							<MuiDialogTitle className='text-center'>
								Mensagens
							</MuiDialogTitle>
							<MuiDialogContent>
								{
									isNullOrEmpty(this.state.messageSchedules) ?
										<EmptyContent text="Nenhuma mensagem agendada." /> :
										<table className="table">
											<tr>
												{
													this.state.isDeveloper &&
													<td width={10} />
												}
												<td width={10} />
												<td align='center'><strong>Data e hora</strong></td>
												<td><strong>Usuário</strong></td>
												<td><strong>Mensagem</strong></td>
												<td width={10}></td>
											</tr>
											<tbody>
												{
													this.state.messageSchedules?.map(item =>
														<tr key={item.id}>
															{
																this.state.isDeveloper &&
																<td>
																	<div className='btn-group'>
																		<Tooltip title="Firebase" placement="top">
																			<button type="button" onClick={() => { goToFirebase({ collection: Collection.CALLBACK_QUEUE, id: item.id }) }} className="btn btn-warning text-white">
																				<i className="fas fa-database" />
																			</button>
																		</Tooltip>
																	</div>
																</td>
															}
															<td width={10}>
																{
																	item.status === "scheduled" &&
																	<span className='badge bg-warning mt-2'>Agendada</span>
																}
																{
																	item.status === "processed" &&
																	<span className='badge bg-success mt-2'>Enviada</span>
																}
																{
																	item.status === "processing" &&
																	<span className='badge bg-warning mt-2'>Processando</span>
																}
															</td>
															<td align='center'>{moment(item.scheduledAt.seconds * 1000).format("DD/MM/YYYY [às] HH:mm:ss")}</td>
															<td>{item.createdBy.nome ?? "-"}</td>
															<td>{item.body.message}</td>
															<td width={10}>
																<div className='btn-group'>
																	<button type="button" className="btn btn-primary btn-sm" onClick={(e) => this.showShootingMessageModal(item)}>
																		<i className="fas fa-list" />
																	</button>
																	{
																		item.status !== "processed" || this.state.isDeveloper &&
																		<button type="button" className="btn btn-danger btn-sm" onClick={(e) => this.removeSchedule(item)}>
																			<i className="fas fa-trash" />
																		</button>
																	}
																</div>
															</td>
														</tr>
													)
												}
											</tbody>
										</table>
								}
							</MuiDialogContent>
							<MuiDialogActions>
								<div className='btn-group m-3'>
									<button onClick={this.hideSchedulesAddedModal} className='btn btn-secondary'>Fechar</button>
								</div>
							</MuiDialogActions>
						</Dialog>
						<Dialog maxWidth='sm' fullWidth onClose={this.hideShootingMessageModal} open={this.state.isShowShootingMessageModal}>
							<MuiDialogTitle className='text-center'>
								Leads da mensagem
							</MuiDialogTitle>
							<MuiDialogContent>
								<div className='row'>
									<table className="table table-striped">
										<tr>
											<td><strong>Lead</strong></td>
											<td><strong>Celular</strong></td>
											<td width={10} />
										</tr>
										<tbody>
											{
												this.state.shootingLeads?.map(item =>
													<tr key={item.id}>
														<td>{item.name ?? "-"}</td>
														<td>{cellphoneMask(item.phone)}</td>
														<td>
															{
																this.state.currentShootingMessage.status === "processed" ?
																	<button onClick={(e) => this.showWhatsAppMessage(item)} className='btn btn-success btn-sm'>
																		<i className="fas fa-comments" />
																	</button> :
																	<button onClick={(e) => this.removeLeadFromMessage(item)} className='btn btn-danger btn-sm'>
																		<i className="fas fa-trash" />
																	</button>
															}
														</td>
													</tr>
												)
											}
										</tbody>
									</table>
								</div>
							</MuiDialogContent>
							<MuiDialogActions>
								<div className='btn-group m-3'>
									<button onClick={this.hideShootingMessageModal} className='btn btn-secondary'>Fechar</button>
								</div>
							</MuiDialogActions>
						</Dialog>
						<Dialog fullWidth maxWidth="lg" onClose={this.hideWhatsAppMessages} open={this.state.showWhatsAppMessagesModal}>
							<MuiDialogContent>
								<WhatsAppMessageListBody referenceId={this.state.referenceId} />
							</MuiDialogContent>
							<MuiDialogActions>
								<button onClick={this.hideWhatsAppMessages} className='btn btn-secondary m-3'>Fechar</button>
							</MuiDialogActions>
						</Dialog>
						<Dialog maxWidth='xs' fullWidth onClose={this.hidePriceModal} open={this.state.isShowPriceModal}>
							<MuiDialogTitle className='text-center'>
								Valor do negócio
							</MuiDialogTitle>
							<MuiDialogContent>
								<div className='row'>
									<div className='col-lg-12'>
										<label>Valor</label>
										<CurrencyInput value={this.state.priceTotal && this.state.priceTotal} prefix="R$" className='form-control' onChangeEvent={this.changePriceTotal} />
									</div>
								</div>
							</MuiDialogContent>
							<MuiDialogActions>
								<div className='btn-group m-3'>
									<button onClick={this.hidePriceModal} className='btn btn-secondary'>Fechar</button>
									<button onClick={this.confirmPriceTotal} className='btn btn-success'>Confirmar</button>
								</div>
							</MuiDialogActions>
						</Dialog>
						<Dialog maxWidth='md' fullWidth onClose={this.hideSettingsModal} open={this.state.isShowSettingsModal}>
							<MuiDialogTitle className='text-center'>
								Configurações
							</MuiDialogTitle>
							<MuiDialogContent>
								<div className='row'>
									<h5>Mensagens padrões</h5>
									<div className='col-lg-6'>
										<label>Boas vindas ( até 20 vagas )</label>
										<textarea className='form-control' onChange={(e) => this.setState({ templateMensagemBoasVindasComercialWhatsApp: e.target.value })} rows={10}>{this.state.templateMensagemBoasVindasComercialWhatsApp}</textarea>
									</div>
									<div className='col-lg-6'>
										<label>Boas vindas ( acima de 20 vagas )</label>
										<textarea className='form-control' onChange={(e) => this.setState({ templateMensagemBoasVindas2ComercialWhatsApp: e.target.value })} rows={10}>{this.state.templateMensagemBoasVindas2ComercialWhatsApp}</textarea>
									</div>
									<div className='col-lg-12 mt-3'>
										<AlertSuccess tag="Variaveis">
											<span><strong>{`{{REPRESENTANTE}}`}</strong> para o nome do representante.</span> <br />
											<span><strong>{`{{VAGAS}}`}</strong> a quantidade de vagas do estabelecimento.</span>
										</AlertSuccess>
									</div>
								</div>
							</MuiDialogContent>
							<MuiDialogActions>
								<div className='btn-group m-3'>
									<button onClick={this.hideSettingsModal} className='btn btn-secondary'>Fechar</button>
									<button onClick={this.confirmSettings} className='btn btn-success'>Confirmar</button>
								</div>
							</MuiDialogActions>
						</Dialog>
					</div>
				}
			</NavBar>
		);
	}
}

export default LeadsManager;